import { Fragment } from 'react'

import OrganizationsFilter from '../../../Shared/Filters/OrganizationsFilter'
import StorageFacilitiesFilter from '../../../Shared/Filters/StorageFacilitiesFilter'
import PackageUnitsFilter from '../../../Shared/Filters/PackageUnitsFilter'

function PackageUnitInventoryFilter({ state, dispatchState }) {
  return (
    <Fragment>
      <OrganizationsFilter state={state} dispatchState={dispatchState} />
      <StorageFacilitiesFilter state={state} dispatchState={dispatchState} />
      <PackageUnitsFilter state={state} dispatchState={dispatchState} />
    </Fragment>
  )
}

export default PackageUnitInventoryFilter
